import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useRespondToMessageRequestMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, ...t }) => r.respondToMessageRequest(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.messageRequests() }), i.invalidateQueries({ queryKey: e.conversations() });
		}
	});
};
//#endregion
export { i as useRespondToMessageRequestMutation };
